import {createContext} from 'react';

const PeopleContext = createContext();

export default PeopleContext;
